import React from 'react';
import {StyleSheet} from 'react-native';

import theme from '../../../style/theme';
import {Icon} from '../../Icon';
import Text from '../../themed/Text';
import PressableWithOpacityFeedback from '../../ui-controls/PressableWithOpacityFeedback';

type BackButtonProps = {
  onPress: () => void;
};

function BackButton({onPress}: BackButtonProps) {
  return (
    <PressableWithOpacityFeedback onPress={onPress} style={styles.container}>
      <Icon name="arrow-left-long" size={16} color={styles.text.color} />
      <Text style={styles.text}>Back</Text>
    </PressableWithOpacityFeedback>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 5,
  },
  text: {
    color: theme.colour.background.button.primary,
    paddingLeft: 8,
    paddingTop: 0,
  },
});

export default BackButton;
